import { render } from "./App.vue?vue&type=template&id=5a26a978"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5a26a978&lang=scss"
script.render = render

export default script